import { FrameTimerPool } from "../Utils/FrameTimerPool";
import { PlayList } from "../Components/Sounds/PlayList";

export class ResetCssAnimations {
    public static handle(): void {
        window.addEventListener("orientationchange", function () {
            let elements = document.getElementsByClassName("resetCssAnimation") as HTMLCollectionOf<HTMLElement>;
            for (let i = 0; i < elements.length; i++) {
                let el = elements.item(i);
                el.style.animation = "none";
                setTimeout(() => (el.style.animation = null), 100);
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ResetCssAnimations.ts
 **/